import PropTypes from 'prop-types';

import Layout from 'components/Layout';
import HeadWithNoIndexAndNoFollow from 'components/Seo/HeadWithNoIndexAndNoFollow';

import BadgesShowcase from './BadgesShowcase';
import Interactions from './Interactions';
import MainInfos from './MainInfos';
import Sidebar from './Sidebar';

const GA_EVENT_CATEGORY = 'user_profile';

const UserProfile = ({ badges, user }) => (
  <>
    <HeadWithNoIndexAndNoFollow
      description={`Perfil de usuário de ${user.userName} no Promobit.`}
      title={`${user.userName} | Promobit`}
    />
    <Layout
      className="pt-6 md:pt-14"
      withGridLayout={false}
      maxWidthOnMobileDevices
    >
      <MainInfos gaEventCategory={GA_EVENT_CATEGORY} user={user} />
      <BadgesShowcase badges={badges} gaEventCategory={GA_EVENT_CATEGORY} />
      <main className="mt-4 grid auto-rows-max grid-cols-4 gap-x-4 pb-8 md:mt-6 md:grid-cols-12">
        <div className="col-span-4 flex-nowrap md:col-span-12 xl:col-span-9">
          <Interactions
            gaEventCategory={GA_EVENT_CATEGORY}
            userId={user.userId}
          />
        </div>
        <Sidebar gaEventCategory={GA_EVENT_CATEGORY} userId={user.userId} />
      </main>
    </Layout>
  </>
);

UserProfile.propTypes = {
  badges: PropTypes.arrayOf(
    PropTypes.shape({
      badgeId: PropTypes.number.isRequired,
      badgeImage: PropTypes.string.isRequired,
      badgeName: PropTypes.string.isRequired,
    })
  ).isRequired,
  user: PropTypes.shape({
    userId: PropTypes.number.isRequired,
  }),
};

export default UserProfile;
